
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-menu",
      function () {
        return require("private-next-pages/digital-menu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/digital-menu"])
      });
    }
  